import { combineReducers } from 'redux';
import { variantsLoading, variantsError, variants } from 'features/variants';
import {
  mainInfoloading,
  mainInfoError,
  RESET,
  FETCH_PRODUCT_MAIN_INFO,
  SET_PRODUCTID,
  productMainInfo as info,
} from './ducks/product-main-info';

import { mediaLoading, mediaError, productMedia as media, FETCH_PRODUCT_MEDIA } from './ducks/product-media';
import {
  FETCH_PRODUCT_MERCHANT_INFO,
  merchantError,
  merchantInfo as merchant,
  merchantLoading,
} from './ducks/product-merchant-info';
import { TINT_SERVICE_ACTIONS, tintService } from './ducks/product-tint-service';

export const product = combineReducers({
  mainInfoloading,
  mainInfoError,
  info,
  mediaLoading,
  mediaError,
  media,
  variantsLoading,
  variantsError,
  variants,
  merchant,
  merchantError,
  merchantLoading,
  tintService,
});

export const productActions = {
  RESET,
  FETCH_PRODUCT_MAIN_INFO,
  SET_PRODUCTID,
  FETCH_PRODUCT_MEDIA,
  FETCH_PRODUCT_MERCHANT_INFO,
  ...TINT_SERVICE_ACTIONS,
};

export * from './ducks/selectors';
export * from './types';
export * from './constants';
export * from './components';

export { FETCH_PRODUCT_MAIN_INFO, FETCH_PRODUCT_MEDIA, FETCH_PRODUCT_MERCHANT_INFO, RESET };
